import { PropTypes } from 'prop-types';
import React from 'react';

import CardImageBasedSideImage from '../Cards/CardImageBased/CardImageBasedSideImage';

const HomepageActiveEconomySidebar = ({ activeEconomy }) => {
  return (
    <div className="">
      <div className="px-6 mb-4 lg:mb-12 sm:mb-6 lg:px-0 sm:px-10">
        <h4 className="stink-h4">The Active Economy</h4>
        <p className="pb-4 mt-2 border-b lg:mt-4 stink-body-3 text-slate border-smoke">
          Six stories to get you started in a health and fitness business
        </p>
      </div>

      <div className="grid grid-flow-col px-6 overflow-auto lg:grid-flow-row gap-y-8 lg:px-0 sm:px-10 no-scrollbar gap-x-6 lg:gap-x-0">
        {activeEconomy.map((item) => {
          const { cardImage, id, publishedDate, slug, title } = item;

          return (
            <div key={id} className="w-56 lg:w-full">
              <CardImageBasedSideImage
                date={publishedDate}
                image={cardImage}
                slug={slug}
                title={title}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

HomepageActiveEconomySidebar.propTypes = {
  activeEconomy: PropTypes.array,
};

export default HomepageActiveEconomySidebar;
